module.exports = __webpack_public_path__ + "img/P150T_weapon_86.88d05e98.png";